import color from "../../../../constants/color";

const styles = {


  avatar: {
    width: { xs: "50px", sm: "60px", md: "70px" },
    height: { xs: "50px", sm: "60px", md: "70px" },
    marginBottom: "5px",
    border: "1px solid lightGray",
    padding: "10%",
    flexShrink: 0,
  }, 
  searchInput: {
    flex: 1,
    color: "#202020",
    placeholderColor: "#202020", 
    fontSize: "12px",
    
  },

  mainBox: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    mt: 3, 
    justifyContent: "space-between",
    alignItems: { xs: "stretch", md: "center" },
    mx: { xs: 2, sm: 3 },
    gap: { xs: 2, md: 0 },
  },
  searchSection: {  
    backgroundColor: color.card,
    borderRadius: "30px",
    width: { xs: "30%", md: "30%" },
    display: "flex",
    minWidth: 0, // Prevent overflow
  },
  createJobButtonBox: {
    display: "flex",
    justifyContent: { xs: "flex-start", md: "flex-end" },
    alignItems: "center",
  },
  buttonBox: {
    mt: 2,
    width: "100%",
  },

  gridContainer: {
    m: { xs: 1, sm: 2 },
    width: "100%",
    justifyContent: { xs: "center", sm: "flex-start" },
  },
  gridSection: {
    backgroundColor: color.card, 
    borderRadius: "20px", 
    p: { xs: 1.5, sm: 2 , md : 2 },
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  innerBox: {
    display: "flex", 
    justifyContent: "flex-start",
    width: "100%",
  },
  avatarGrid: {
    display: "flex", 
    alignItems: "center",
    width: "100%",
    minWidth: 0, // Prevent overflow
  },
  companyInfo: {
    ml: { xs: 1, sm: 2 },
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  salaryLocationBox: {
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    mt: 2,
    gap: 1,
    flexWrap: { xs: "wrap", sm: "nowrap" },
  },
  salaryBox: {
    minWidth: 0,
    flex: { xs: "1 1 100%", sm: "0 1 auto" },
  },
  locationBox: {
    display: "flex", 
    alignItems: "center",
    gap: "4px",
    minWidth: 0,
    flex: { xs: "1 1 100%", sm: "0 1 auto" },
  },
  alignBox: {
    alignItems: "center", 
    m: 2, 
    // width: "auto",
    display: "flex",
    justifyContent: "center", 


  },
  companyName: {
    color: color.lightText, 
    fontSize: { xs: "14px", sm: "16px" }, 
    fontWeight: "600",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }, 
  position: {
    fontSize: { xs: "14px", sm: "16px" }, 
    fontWeight: "600",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  locationText: {
    fontSize: { xs: "11px", sm: "12px" }, 
    fontWeight: "400",
    color: color.lightText,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  content: {
    fontSize: { xs: "11px", sm: "12px" }, 
    fontWeight: "400", 
    mt: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "180px", // ensures approximate 20 chars in most font sizes on sm devices
  },
  openingJobs: {
    fontSize: "14px", 
    fontWeight: "600",
  },
  viewBtn: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A", 
    width: "100%",
    fontSize: { xs: "11px", sm: "12px" },
    fontWeight: "400",
    py: { xs: 1, sm: 1.5 },
  },
  jobButton: {
    borderRadius: 50, 
    textTransform: "none", 
    backgroundColor: "#28AA4A",
    fontSize: { xs: "11px", sm: "12px" },
    px: { xs: 2, sm: 3 },
    py: { xs: 1, sm: 1.5 },
    whiteSpace: "nowrap",
  },
}; export default styles;